import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import ThemeProvider from './theme';
import { Provider } from 'react-redux';
import { store, GlobalHistory, GlobalSetQueryParams } from './base';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { SnackbarUtilsConfigurator as SnackbarConfigurator } from './common/utils/snackbar.utils';
import RemoveTrailingSlash from './components/RemoveTrailingSlash';
import { HelmetProvider } from 'react-helmet-async';

const SnackbarUtilsConfigurator: React.FC = () => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    useEffect(() => {
        SnackbarConfigurator.setEnqueueSnackbar(enqueueSnackbar);
        SnackbarConfigurator.setCloseSnackbar(closeSnackbar);
    }, [enqueueSnackbar, closeSnackbar]);

    return null;
};

ReactDOM.createRoot(document.getElementById('root')!).render(
    <HelmetProvider>
        <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
            <Provider store={store}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <BrowserRouter>
                        <RemoveTrailingSlash />
                        <ThemeProvider>
                            <SnackbarProvider>
                                <SnackbarUtilsConfigurator />
                                <GlobalHistory />
                                <GlobalSetQueryParams />
                                <App />
                            </SnackbarProvider>
                        </ThemeProvider>
                    </BrowserRouter>
                </LocalizationProvider>
            </Provider>
        </GoogleOAuthProvider>
    </HelmetProvider>
);
